import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '@/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class LockScreenService {
    private lockScreenSubject = new BehaviorSubject<boolean>(localStorage.getItem('isLocked') === 'true');
    lockScreen$ = this.lockScreenSubject.asObservable();

    constructor() {
        if (!environment.production) {
            this.unLock();
        }
    }

    lock() {
        localStorage.setItem('isLocked', 'true');
        this.lockScreenSubject.next(true);
    }

    unLock() {
        localStorage.setItem('isLocked', 'false');
        this.lockScreenSubject.next(false);
    }
}
